import { createAction, createReducer } from '@reduxjs/toolkit'

// Actions
export const getDocumentsByStatus = createAction(
	'workflow/GET_DOCUMENTS_BY_STATUS'
)
export const getDocumentsByStatusSuccess = createAction(
	'workflow/GET_DOCUMENTS_BY_STATUS_SUCCESS'
)
export const getDocumentsByStatusFailure = createAction(
	'workflow/GET_DOCUMENTS_BY_STATUS_FAILURE'
)

// Reducer
const initialState = {
	loading: false,
	error: null,
	groups: {},
}

export default createReducer(initialState, (builder) => {
	builder
		.addCase(getDocumentsByStatus, (state) => {
			state.loading = true
		})
		.addCase(getDocumentsByStatusSuccess, (state, action) => {
			state.loading = false
			state.groups = action.payload
			state.error = null
		})
		.addCase(getDocumentsByStatusFailure, (state, action) => {
			state.loading = false
			state.error = action.payload
		})
})

export * from './sagas'
